import { SCOPE as PARENT_SCOPE } from '../types';

const SCOPE = `${PARENT_SCOPE}.tempDashboard`;

export default SCOPE;
